export default __webpack_public_path__ + "img/client.7e78ebe7.svg";